import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7e7ba001-478f-49ec-a870-6d8a68c3834a",
    content: "Increased if we add some absorption material on the ceilling",
    options: {},
  },
  {
    id: "f7429084-86e7-495b-8b1d-d6c6451dc84a",
    content: "Decreased if we add some absoprtion material on the side wall",
    options: {},
  },
  { id: "50165dc2-65a7-4bbf-b31e-8e4fd1706b97", content: "The sound pressure level will be the same", options: {} },
  {
    id: "a58272ab-ca89-4986-b6cf-96d81af63484",
    content: "The sound pressure level do not depend on absorption",
    options: {},
  },
];

export const task: Task = {
  id: "b157592c-95b1-4a36-973e-080a3fbefb33",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  solutionType: "select",
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f7429084-86e7-495b-8b1d-d6c6451dc84a"],
};
